import type { StateCreator } from 'zustand'

interface CommandMenuBase {
  commandMenuOpen: boolean
}

interface CommandMenuActions {
  setCommandMenuOpen: (
    nextOpen:
      | CommandMenuBase['commandMenuOpen']
      | ((
          currentOpen: CommandMenuBase['commandMenuOpen']
        ) => CommandMenuBase['commandMenuOpen'])
  ) => void
}

export interface CommandMenuState extends CommandMenuBase, CommandMenuActions {}

export const createCommandMenuStore: StateCreator<CommandMenuState> = (
  set
) => ({
  commandMenuOpen: false,
  setCommandMenuOpen: (nextOpen) => {
    set((state) => ({
      commandMenuOpen:
        typeof nextOpen === 'function'
          ? nextOpen(state.commandMenuOpen)
          : nextOpen,
    }))
  },
})
